<template>
    <div class="text-center mt-4">
        <button class="btn btn-primary" type="button" disabled>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Enviando...
        </button>
    </div>
</template>